import 'date-fns';
import React, { useEffect, useCallback, useMemo } from 'react';
import { format, parseISO, isValid } from 'date-fns';
import {
  Typography, Grid, Button, Paper, makeStyles, createStyles, Theme, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, CircularProgress
} from '@material-ui/core';
import QAContentCR from '../component/portal/qaedit/customer/QAContent'
import QAEditAreaCR from '../component/portal/qaedit/customer/QAEditArea'
import QAContentEE from '../component/portal/qaedit/employee/QAContent'
import QAEditAreaEE from '../component/portal/qaedit/employee/QAEditArea'
import QABasicEdit from '../component/portal/qaedit/employee/QABasicEdit'
import { getUserInfo, typeUserInfo } from '../api/helpline/user'
import { getCategory, getMember, typeCategory, typeMemberList } from '../api/helpline/master'
import { getQaContent, getQaEnvironment, typeQaContent, getQaRest, typeQaRest, updateQaRest, typeUpdateForm, getAttachedFile, getUserInfoList, typeUserInfoList, typeQaEnvironment, putCloseNotice, putQaRest, deleteQaRest } from '../api/helpline/qa'
import { lookup } from 'mime-types'
import * as importpath from 'path'
import { useDispatch, useGlobalState } from '../provider/Provider';
import { useHistory, useParams } from 'react-router-dom';
import NotFound from './NotFound'
import WarningIcon from '@material-ui/icons/Warning';
import FormAreaCR from '../component/portal/qaedit/customer/FormArea'
import FormAreaEE from '../component/portal/qaedit/employee/FormArea'
import { getContractItemList, typeContractItemList } from '../api/helpline/keiyaku';
import { cisUser } from '../User';
import { green } from '@material-ui/core/colors';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogtitle: {
      display: 'flex',
      alignItems: 'center',
    },
    wrapper: {
      position: 'relative',
    },
    buttonProgress: {
      color: green[500],
      position: 'absolute',
      top: '50%',
      marginTop: -12,
      marginLeft: -44,
    },
  }),
);

interface Props {
  pagehome: boolean,
  handleError: (err: any) => void,
  handleNotificationOpen: (level: 'success' | 'info' | 'warning' | 'error', message: string) => void,
}

interface Obj {
  [name: string]: string,
}

const rolecustomer = process.env.REACT_APP_ROLE_CUSTOMER!
const newservice = process.env.REACT_APP_KEIYAKU_NEW_SERVICE!
const appservice = process.env.REACT_APP_KEIYAKU_NEW_APP!
const webservice = process.env.REACT_APP_KEIYAKU_NEW_WEBTECHINICAL!

const QAEdit: React.FC<Props> = (props) => {
  const dispatch = useDispatch()
  const globalState = useGlobalState('user')
  const globalqalistState = useGlobalState('qalist')
  const globalconlistState = useGlobalState('contractlist')
  const { userId, token, role } = globalState
  const classes = useStyles()
  const history = useHistory()
  //@ts-ignore
  const { qano } = useParams()
  const decode_qano = useMemo(() => {
    try {
      if (qano) {
        const decno = atob(qano)
        if (decno.match(/[0-9]{11}/g)) {
          return decno
        } else {
          return qano //decode失敗
        }
      } else {
        return ''//decode失敗
      }
    } catch {
      return qano//decode失敗
    }
  }, qano)
  const { pagehome, handleError, handleNotificationOpen } = props
  const dateFormat = (datevalue: Date | string): string => {
    let date = datevalue
    if (typeof date === 'string') {
      date = parseISO(date)
    }
    if (isValid(date)) {
      return format(date, 'yyyy/MM/dd')
    } else {
      return '　'
    }
  }
  const [qaContent, setQaContent] = React.useState<typeQaContent>()
  const [qaEnv, setQaEnv] = React.useState<typeQaEnvironment>()
  const [userInfoList, setUserInfoList] = React.useState<typeUserInfoList>()
  const [loading, setLoading] = React.useState<boolean>(false)
  const [mailDialog, setMailDialog] = React.useState(false)
  const [fileloading, setFileloading] = React.useState<boolean>(false)
  const [qaRest, setQaRest] = React.useState<typeQaRest[]>([])
  const [member, setMember] = React.useState<typeMemberList>()
  const [qastatus, setQastatus] = React.useState<typeCategory[]>([])
  const [qastatusorg, setQastatusorg] = React.useState<typeCategory[]>([])
  const [questionkind, setQuestionkind] = React.useState<typeCategory[]>([])
  const [incidentdialog, setIncidentdialog] = React.useState<boolean>(false)
  const [selectKeiyaku, setSelectKeiyaku] = React.useState<typeContractItemList | undefined>()
  //問合わせ方法
  const [answerway, setAnswerway] = React.useState<typeCategory[]>([])
  //useEffect動作用
  const [submitcount, setSubmitCount] = React.useState<number | null>(1)
  const [qaEnvironment, setQaEnvironment] = React.useState<Obj>({})
  const [qabasicEdit, setQabasicEdit] = React.useState<boolean>(false)
  const [userInfo, setUserInfo] = React.useState<typeUserInfo | undefined>()
  const [incidentAddFlg, setIncidentAddFlg] = React.useState(qaContent?.incidentAddFlg === '1')
  const [newfiles, setNewfiles] = React.useState({
    attachedFile: '',
    attachedFileData: '',
    attachedFile2: '',
    attachedFile2Data: '',
    attachedFile3: '',
    attachedFile3Data: '',
  })
  const [closeform, setCloseform] = React.useState({
    qaKindClsCd: '0',
    qaTotalTime: 0,
    incidentUse: 0,
    incidentAddFlg: qaContent?.incidentAddFlg === '1' ? '1' : '0',
  })
  const [totaltime, setTotaltime] = React.useState<{ hours: string, minutes: string, isNum: boolean }>({
    hours: '0',
    minutes: '0',
    isNum: false,
  })
  const [deleteopen, setDeleteOpen] = React.useState(false)
  //QARestEdit
  const [editindex, setEditIndex] = React.useState(-1)
  const handleDeleteOpen = () => {
    if (editindex !== -1) {
      setDeleteOpen(true)
    }
  }
  const handleDeleteClose = () => {
    setDeleteOpen(false)
  }
  const onDeleteQARest = () => {
    if (qaRest[editindex].qaNo && qaRest[editindex].qaSerialNo) {
      setLoading(true)
      setSubmitCount(null)
      deleteQaRest(userId, token, role, qaRest[editindex].qaNo, qaRest[editindex].qaSerialNo,).then(res => {
        handleDeleteClose()
        handleQARestEditClose()
        handleAddSubmitCount()
        setLoading(false)
      }).catch(err => { setLoading(false); handleDeleteClose(); handleAddSubmitCount(); handleError(err) })
    }
  }
  const handleQARestEditOpen = (editindexnum: number) => {
    setEditIndex(editindexnum)
  }
  const handleQARestEditClose = () => {
    setEditIndex(-1)
  }
  const handleCloseIncident = () => {
    setIncidentdialog(false)
    setLoading(false)
  }
  const handleOpenIncident = () => {
    setIncidentdialog(true)
  }

  const handleincidentAddFlg = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIncidentAddFlg(event.target.checked)
  }
  //incidentAddFlg変更
  useEffect(() => {
    if (incidentAddFlg) {
      setCloseform({
        ...closeform,
        incidentAddFlg: '1'
      })
    } else {
      setCloseform({
        ...closeform,
        incidentAddFlg: '0'
      })
    }
  }, [incidentAddFlg])

  useEffect(() => {
    setNewfiles({//更新用ファイルState初期化
      attachedFile: '',
      attachedFileData: '',
      attachedFile2: '',
      attachedFile2Data: '',
      attachedFile3: '',
      attachedFile3Data: '',
    })
    const qaStatus = () => {
      if (editindex === -1 && qaContent?.qaStatusClsCd === '0') {
        return '0'
      } else if (qaRest[editindex]?.qaFlg === 'd') {
        return 'd'
      } else if (qaRest[editindex]?.qaFlg === 'Q') {
        return '3'
      } else if (qaRest[editindex]?.qaStatusClsCd === '4' && editindex + 1 === qaRest.length) {
        return '4'
      } else {
        return '2'
      }
    }
    if (editindex !== -1) {
      setForm({//Formに内容を反映
        ...form,
        qaNo: qaRest[editindex].qaNo,//*、固定
        qaFlg: qaRest[editindex].qaFlg,
        answerClsCd: qaRest[editindex].answerClsCd,
        answerContents: qaRest[editindex].answerContents ? qaRest[editindex].answerContents : '',
        aPersonCd: qaRest[editindex].aPersonCd,
        attachedFile: qaRest[editindex].attachedFile!,
        attachedFileData: '',
        attachedFile2: qaRest[editindex].attachedFile2!,
        attachedFile2Data: '',
        attachedFile3: qaRest[editindex].attachedFile3!,
        attachedFile3Data: '',
        answeSt: dateFormat(new Date(qaRest[editindex].answeSt!)),//*、固定
        createCd: qaRest[editindex].createCd!,//*、固定
        qaStatusClsCd: qaStatus(),
        updateDate: dateFormat(new Date(Date.now())),//更新
        updateCd: userId,//更新
        qaSerialNo: qaRest[editindex].qaSerialNo!,
        note: qaRest[editindex].note!,
      })
    } else {
      setForm({//Form初期化
        ...form,
        answerContents: '',
        qaNo: decode_qano,//*、固定
        qaFlg: role === rolecustomer ? 'Q' : 'A',
        answerClsCd: '0',
        aPersonCd: '',
        attachedFile: '',
        attachedFileData: '',
        attachedFile2: '',
        attachedFile2Data: '',
        attachedFile3: '',
        attachedFile3Data: '',
        answeSt: dateFormat(new Date(Date.now())),//*、固定
        createCd: userId,//*、固定
        qaStatusClsCd: qaStatus(),
        note: '',
      })
    }
  }, [editindex])

  const [form, setForm] = React.useState<typeUpdateForm>({
    qaNo: decode_qano,//*、固定
    qaFlg: role === rolecustomer ? 'Q' : 'A',
    answerClsCd: '0',
    answerContents: '',
    aPersonCd: '',
    attachedFile: '',
    attachedFileData: '',
    attachedFile2: '',
    attachedFile2Data: '',
    attachedFile3: '',
    attachedFile3Data: '',
    qaSerialNo: '',
    answeSt: dateFormat(new Date(Date.now())),//*、固定
    createCd: userId,//*、固定
    createDate: '',
    qaStatusClsCd: '',
    qaKindClsCd: '0',
    note: '',
    updateCd: '',
    updateDate: '',
    qaTotalTime: null,
    incidentUse: null,
    incidentAddFlg: null,
  })

  const handleChangeMinutes = (value: string) => {
    setTotaltime({
      ...totaltime,
      minutes: value
    })
  }

  const hadleChangeCloseForm = useCallback((event: React.ChangeEvent<{ value: unknown; name?: string | undefined }>) => {
    if (event.target.name === 'hours') {
      setTotaltime({
        ...totaltime,
        hours: event.target.value as string
      })
    } else {
      setCloseform({
        ...closeform,
        [event.target.name as string]: event.target.value as string
      })
    }
  }, [totaltime, closeform])

  const handleCloseMail = () => {
    setMailDialog(false);
  }

  const handleOpenMail = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation()
    setMailDialog(true)
  }

  const handleOpenBasicEdit = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation()
    setQabasicEdit(true)
  }
  const handleCloseBasicEdit = () => {
    setQabasicEdit(false)
  }

  const handleAddSubmitCount = () => {
    if (submitcount) {
      setSubmitCount(submitcount + 1)
    } else {
      setSubmitCount(1)
    }
  }

  const handleChangeForm = useCallback((event: React.ChangeEvent<{ value: unknown; name?: string | undefined }>) => {
    if (typeof event.target.value === 'string') {
      if (event.target.name === 'qaStatusClsCd' && event.target.value === 'd') {
        setForm({
          ...form,
          qaFlg: 'd',
          [event.target.name as string]: event.target.value as string
        })
      } else if (event.target.name === 'qaStatusClsCd' && event.target.value === '3') {
        setForm({
          ...form,
          qaFlg: 'Q',
          [event.target.name as string]: event.target.value as string
        })
      } else {
        setForm({
          ...form,
          [event.target.name as string]: event.target.value as string
        })
      }
    }
  }, [form])

  const handleChangeFile = useCallback(async (files: File[]) => {
    //base64Encode
    const base64Encode = (...parts: any) => {
      return new Promise(resolve => {
        const reader = new FileReader();
        reader.onload = () => {
          if (typeof reader.result === 'string') {
            const offset = reader!.result!.indexOf(',') + 1;
            resolve(reader!.result!.slice(offset));
          }
        };
        reader.readAsDataURL(new Blob(parts));
      });
    }
    if (1 <= files.length && files.length <= 3) {
      let filenameList: string[] = []
      let filedataList: string[] = []
      for (let i = 0; i < files.length; i++) {
        if (files[i]) {
          const file = files[i]
          const encodedFile = await base64Encode(file)
          filenameList.push(file.name)
          filedataList.push(encodedFile as string)
        }
      }
      if (editindex === -1 && filenameList.length !== 0 && filedataList.length !== 0) {
        setForm({
          ...form,
          attachedFile: filenameList[0] ? filenameList[0] : '',
          attachedFileData: filedataList[0] ? filedataList[0] : '',
          attachedFile2: filenameList[1] ? filenameList[1] : '',
          attachedFile2Data: filedataList[1] ? filedataList[1] : '',
          attachedFile3: filenameList[2] ? filenameList[2] : '',
          attachedFile3Data: filedataList[2] ? filedataList[2] : '',
        });
      } else if (editindex !== -1 && filenameList.length !== 0 && filedataList.length !== 0) {
        setNewfiles({
          ...newfiles,
          attachedFile: filenameList[0] ? filenameList[0] : '',
          attachedFileData: filedataList[0] ? filedataList[0] : '',
          attachedFile2: filenameList[1] ? filenameList[1] : '',
          attachedFile2Data: filedataList[1] ? filedataList[1] : '',
          attachedFile3: filenameList[2] ? filenameList[2] : '',
          attachedFile3Data: filedataList[2] ? filedataList[2] : '',
        });
      }
    }
  }, [form, newfiles, editindex])

  const handleRemoveFile = useCallback((filename: string) => {
    for (const [key, value] of Object.entries(form)) {
      if (value === filename) {
        setForm({
          ...form,
          [key]: '',
          [key + 'Data']: ''
        })
      }
    }
    return ''
  }, [form])

  const handleMovePath = () => {
    if (qabasicEdit) {
      handleCloseBasicEdit()
    } else {
      dispatch({ type: 'SET_PAGE', payload: globalState, page: { backpage: true }, qalist: globalqalistState, contractlist: globalconlistState })
      if (pagehome) {
        history.push('/helpline')
      } else {
        history.go(-1)//戻る
      }
    }
  }

  const base64DecodeAsBlob = async (text: string, type: string) => {
    const response = await fetch(`data:${type};base64,` + text);
    return await response.blob();
  }

  const base64Decode = async (text: string, type: string) => {
    const dataURI = `data:${type};base64,` + text
    var byteString = atob(dataURI.split(',')[1]);
    for (var i = 0, l = byteString.length, content = new Uint8Array(l); l > i; i++) {
      content[i] = byteString.charCodeAt(i);
    }
    return new Blob([content], { type: type })
  }

  //QAレスポンス登録・更新+終了時基本情報更新
  const qaRestBasic = async () => {
    const execQaRest = async () => {
      if (editindex === -1) {
        await putQaRest(userId, token, role, decode_qano, form).then(res => {
          handleQARestEditClose()
          handleAddSubmitCount()
          setLoading(false)
        }).catch(err => { setLoading(false); handleAddSubmitCount(); handleError(err) })
      } else {
        //QAレスポンス更新
        const sendform = Object.assign({}, form)
        //newFiles挿入
        if (newfiles.attachedFile || newfiles.attachedFile2 || newfiles.attachedFile3) {
          let keyname: string[] = []
          for (const [key] of Object.entries(newfiles)) {//map用keyname取得
            if (!key.match(/Data/g)) {
              keyname.push(key)
            }
          }
          let emptyform: string[] = []
          keyname.map(value => {//formで空のkeyを取得
            if (!form[value] || form[value].length === 0) {//null,undefinedもしくは文字列0の時、空とみなす
              emptyform.push(value)
            }
          })
          emptyform.map((value, index) => {//formで空のkeyにnewfileを挿入
            sendform[value] = newfiles[keyname[index]]
            sendform[value + 'Data'] = newfiles[keyname[index] + 'Data']
          })
        }
        await updateQaRest(userId, token, role, decode_qano, form.qaSerialNo, sendform).then(res => {
          handleQARestEditClose()
          handleAddSubmitCount()
          setLoading(false)
        }).catch(err => { setLoading(false); handleQARestEditClose(); handleAddSubmitCount(); handleError(err) })
      }
    }
    if (form.qaStatusClsCd === '4' && !displayIncident) {
      form['qaKindClsCd'] = closeform.qaKindClsCd
      form['qaTotalTime'] = closeform.qaTotalTime
      execQaRest()
    } else if (form.qaStatusClsCd === '4' && displayIncident) {
      form['qaKindClsCd'] = closeform.qaKindClsCd
      form['qaTotalTime'] = closeform.qaTotalTime
      form['incidentUse'] = closeform.incidentUse
      if (form['incidentAddFlg'] !== '1') {
        form['incidentAddFlg'] = closeform.incidentAddFlg
      }
      if (incidentRemain - closeform.incidentUse < 0) {
        if (form?.incidentAddFlg === '0') {
          handleOpenIncident()
        } else {
          execQaRest()
        }
      } else {
        execQaRest()
      }
    } else {
      execQaRest()
    }
  }


  //QAレスポンス登録・更新+インシデントフラグ追加時基本情報更新
  const updateIncidentFlg = async () => {
    form['incidentAddFlg'] = '1'
    await qaRestBasic()
    handleCloseIncident()
  }

  const onSubmit = async () => {
    setLoading(true)
    if (form.qaFlg === 'd') {
      form['qaStatusClsCd'] = qaContent?.qaStatusClsCd as string
    }
    setSubmitCount(null)
    //QAレスポンス登録
    if (form.answerClsCd === '6' && form.qaStatusClsCd !== '4') {//回答方法オンサイトインシデント
      if (incidentRemain <= 1) {//残インシデント1以下
        if (qaContent?.incidentAddFlg === '1') {
          //QAレスポンス登録 通常
          await qaRestBasic()
        } else {
          //インシデントダイアログ表示
          handleOpenIncident()
        }
      } else {//残インシデント1を超過
        //QAレスポンス登録 通常
        await qaRestBasic()
      }
    } else {
      //QAレスポンス登録 通常
      await qaRestBasic()
    }
  }


  const fileDownload = (filepath: string) => {
    setFileloading(true);
    (async () => {
      let mime_type = lookup(filepath) || 'application/octet-stream'
      const encodedFile = await getAttachedFile(userId, token, role, filepath).catch(err => { setFileloading(false); handleError(err) })
      if (encodedFile) {
        if (window.navigator.msSaveOrOpenBlob) {
          const decodedFile = await base64Decode(encodedFile, mime_type)
          window.navigator.msSaveOrOpenBlob(decodedFile, importpath.basename(filepath));
        } else {
          const decodedFile = await base64DecodeAsBlob(encodedFile, mime_type as string)
          let link = document.createElement('a');
          link.href = URL.createObjectURL(decodedFile)
          link.download = importpath.basename(filepath)
          link.click()
        }
      }
      setFileloading(false)
    })()
  }

  //初期表示APIコール、送信ボタンクリック時再コール
  useEffect(() => {
    if (userId && token && role && decode_qano && submitcount) {
      setForm({//Form初期化
        ...form,
        answerContents: '',
        qaNo: decode_qano,//*、固定
        qaFlg: role === rolecustomer ? 'Q' : 'A',
        answerClsCd: '0',
        aPersonCd: '',
        attachedFile: '',
        attachedFileData: '',
        attachedFile2: '',
        attachedFile2Data: '',
        attachedFile3: '',
        attachedFile3Data: '',
        answeSt: dateFormat(new Date(Date.now())),//*、固定
        createCd: userId,//*、固定
        qaStatusClsCd: '2',
        note: '',
      })
      setNewfiles({
        attachedFile: '',
        attachedFileData: '',
        attachedFile2: '',
        attachedFile2Data: '',
        attachedFile3: '',
        attachedFile3Data: '',
      })
      let cleanup = false
      getQaContent(userId, token, role, decode_qano).then(res => {
        if (!cleanup) {
          setQaContent(res)
          if (res) {
            if (cisUser(role)) {//社員用
              //QA対応状況
              getCategory('qastatus', userId, token, role).then(qres => {
                if (!cleanup) {
                  setQastatusorg(qres)
                  if (res.qaStatusClsCd === '0') {//未受付時QA編集画面に表示する項目
                    setQastatus(qres.filter(value => {
                      if ((value.categoryCd !== '2') && (value.categoryCd !== '3')) {
                        return value
                      }
                    }))
                  } else {
                    setQastatus([])
                  }
                }
              }).catch(err => handleError(err))
              //回答種別
              getCategory('answerway', userId, token, role).then(ares => {
                if (!cleanup) {
                  //契約項目を取得(インシデント用)
                  getContractItemList(res.custmDepNo, userId, token, role).then(conres => {
                    const val = conres.filter(value => value.keiyakuNo === res.keiyakuNo)
                    if (val && val.length === 1) {
                      setSelectKeiyaku(val[0])
                      if (val[0].keiyakuClsNotes === webservice) {
                        setAnswerway(ares.filter(value => value.categoryCd === '0'))
                      } else if (val[0].keiyakuClsNotes === newservice || val[0].keiyakuClsNotes === appservice) {
                        setAnswerway(ares.filter(value => value.categoryCd === '0' || value.categoryCd === '1' || value.categoryCd === '2' || value.categoryCd === '6'))
                      } else {
                        setAnswerway(ares.filter(value => value.categoryCd === '0' || value.categoryCd === '1' || value.categoryCd === '2' || value.categoryCd === '3' || value.categoryCd === '4'))
                      }
                    }
                  }).catch(err => handleError(err))
                }
              }).catch(err => handleError(err))
              //問合せ区分
              getCategory('questionkind', userId, token, role).then(qres => {
                if (!cleanup) { setQuestionkind(qres) }
              }).catch(err => handleError(err))
            }
            getUserInfo(res.custmDepNo, userId, token, role).then(res => { if (!cleanup) { setUserInfo(res) } }).catch(err => handleError(err))
            getUserInfoList(res.custmDepNo, userId, token, role).then(res => { if (!cleanup) { setUserInfoList(res) } }).catch(err => handleError(err))
            if (res.keiyakuClsCd === '80' || res.keiyakuClsCd === '81') {
              (async () => {
                const env = await getQaEnvironment(userId, token, role, decode_qano).catch(err => handleError(err))
                if (env) {
                  setQaEnv(env)
                  let obj: Obj = {}
                  //SuperStreamバージョン
                  const ss_version = await getCategory('ss_version', userId, token, role).catch(err => handleError(err))
                  if (ss_version) {
                    let ss_versionName = ss_version.filter(value => value.categoryCd === env.ssVersionClsCd)
                    if (ss_versionName.length !== 0) {
                      obj.ss_version = ss_versionName[0].categoryName
                    }
                  }
                  //サーバー環境（OS）
                  const ss_serverOS = await getCategory('ss_serverOS', userId, token, role).catch(err => handleError(err))
                  if (ss_serverOS) {
                    let ss_serverosName = ss_serverOS.filter(value => value.categoryCd === env.serverOsClsCd)
                    if (ss_serverosName.length !== 0) {
                      obj.ss_serverOS = ss_serverosName[0].categoryName
                    }
                  }

                  //クライアント環境（OS）
                  const ss_clientOS = await getCategory('ss_clientOS', userId, token, role).catch(err => handleError(err))
                  if (ss_clientOS) {
                    let ss_clientosName = ss_clientOS.filter(value => value.categoryCd === env.clientOsClsCd)
                    if (ss_clientosName.length !== 0) {
                      obj.ss_clientOS = ss_clientosName[0].categoryName
                    }
                  }

                  if (res.keiyakuClsCd === '80') {
                    //サーバー環境（DB）
                    const ss_serverDB = await getCategory('ss_serverDB', userId, token, role).catch(err => handleError(err))
                    if (ss_serverDB) {
                      let ss_serverdbName = ss_serverDB.filter(value => value.categoryCd === env.serverDbClsCd)
                      if (ss_serverdbName.length !== 0) {
                        obj.ss_serverDB = ss_serverdbName[0].categoryName
                      }
                    }

                    //アプリケーションサーバー
                    const ss_applicationserver = await getCategory('ss_applicationserver', userId, token, role).catch(err => handleError(err))
                    if (ss_applicationserver) {
                      let ss_applicationserverName = ss_applicationserver.filter(value => value.categoryCd === env.serverAsClsCd)
                      if (ss_applicationserverName.length !== 0) {
                        obj.ss_applicationserver = ss_applicationserverName[0].categoryName
                      }
                    }

                    //クライアント環境（DB）
                    const ss_clientDB = await getCategory('ss_clientDB', userId, token, role).catch(err => handleError(err))
                    if (ss_clientDB) {
                      let ss_clientdbName = ss_clientDB.filter(value => value.categoryCd === env.clientDbClsCd)
                      if (ss_clientdbName.length !== 0) {
                        obj.ss_clientDB = ss_clientdbName[0].categoryName
                      }
                    }

                  } else {
                    //サーバー環境（接続）
                    const ss_serverConnect = await getCategory('ss_serverConnect', userId, token, role).catch(err => handleError(err))
                    if (ss_serverConnect) {
                      let ss_serverconnectName = ss_serverConnect.filter(value => value.categoryCd === env.serverConnectClsCd)
                      if (ss_serverconnectName.length !== 0) {
                        obj.ss_serverConnect = ss_serverconnectName[0].categoryName
                      }
                    }
                  }
                  setQaEnvironment(obj)
                }
              })()
            }
            getQaRest(userId, token, role, decode_qano).then(res => setQaRest(res)).catch(err => handleError(err))
          }
        }
        if (cisUser(role) && res) {
          getMember(userId, token, role, res.qPersonCd).then(res => {
            setMember(res)
          }).catch(err => handleError(err))
        }
      }).catch(err => handleError(err))
      return () => { cleanup = true }
    }
  }, [submitcount])

  const fileRemoveButton = useCallback((index: number) => {
    if (index === 1) {
      setForm({ ...form, 'attachedFile': '', })
    } else if (index === 2) {
      setForm({ ...form, 'attachedFile2': '', })
    } else {
      setForm({ ...form, 'attachedFile3': '', })
    }
  }, [form])

  const displayIncident = useMemo(() => {
    if (selectKeiyaku) {
      if (selectKeiyaku.keiyakuClsNotes === newservice || selectKeiyaku.keiyakuClsNotes === appservice) {
        return true
      } else {
        return false
      }
    } else { return false }
  }, [selectKeiyaku])

  const parsedNum = (all: any) => {
    let num = 0
    if (all) {
      num = Number(all)
      if (isNaN(num)) { num = 0 }
    }
    return num
  }

  const incidentValidCount = useMemo((): number => {
    if (qaContent && (qaContent.incidentCount || qaContent.incidentAddCount)) {
      return parsedNum(qaContent.incidentCount) + parsedNum(qaContent.incidentAddCount)
    } else { return 0 }
  }, [qaContent])

  const incidentRemain = useMemo(() => {
    if (qaContent && (qaContent.incidentUsedCount || incidentValidCount)) {
      return incidentValidCount - parsedNum(qaContent.incidentUsedCount)
    } else { return 0 }
  }, [incidentValidCount, qaContent])


  const incidentReqired = useMemo((): boolean => {
    if (selectKeiyaku) {
      if (!(selectKeiyaku.keiyakuClsNotes === newservice) && !(selectKeiyaku.keiyakuClsNotes === appservice)) {//新サービスでもなく、新アプリサービスでもない
        return false
      } else if (form.answerClsCd === '6') {//回答方法がオンサイトインシデント
        return true //必須
      } else if (qaRest.map(value => value.answerClsCd === '6').includes(true)) {//回答応答内の回答方法にオンサイトインシデントがある
        return true//必須
      } else {
        return false
      }
    } else { return false }
  }, [selectKeiyaku, form.answerClsCd, qaRest])

  const incidentcheck = useMemo((): boolean => {
    if (closeform.incidentUse) {
      let parseduse = Number(closeform.incidentUse)
      if (isNaN(parseduse)) {
        return true
      } else if (incidentReqired && parseduse === 0) {
        return true
      } else if (incidentReqired && selectKeiyaku?.keiyakuClsNotes === appservice && parseduse % 0.5 !== 0) {
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  }, [closeform.incidentUse, incidentReqired, selectKeiyaku])

  useEffect(() => {
    if (incidentReqired && (selectKeiyaku?.keiyakuClsNotes === newservice || selectKeiyaku?.keiyakuClsNotes === appservice)) {
      setCloseform({ ...closeform, incidentUse: 1 })
    } else {
      setCloseform({ ...closeform, incidentUse: 0 })
    }
  }, [form.answerClsCd, selectKeiyaku, incidentReqired])

  //QA対応時間計算
  useEffect(() => {
    if (totaltime.hours || totaltime.minutes) {
      let parsedh = Number(totaltime.hours)
      let parsedm = Number(totaltime.minutes) / 60
      if (isNaN(parsedh) || (!isNaN(parsedh) && !Number.isInteger(parsedh))) {//数値でない もしくは 数値かつ整数値ではない
        setTotaltime({ ...totaltime, isNum: false })
        setCloseform({ ...closeform, qaTotalTime: 0, })
      } else {
        setTotaltime({ ...totaltime, isNum: true })
        setCloseform({ ...closeform, qaTotalTime: parsedh + parsedm })
      }
    }
  }, [totaltime.hours, totaltime.minutes])


  //aPersonCd,qaStatusClsCd挿入(qaContentに依存)
  useEffect(() => {
    let apersoncd = qaContent?.qPersonCd
    let qaStatusClsCd = qaContent?.qaStatusClsCd
    if (role === rolecustomer) {//顧客用
      if (apersoncd && qaStatusClsCd) {
        setForm({
          ...form,
          'aPersonCd': apersoncd,
          'qaStatusClsCd': qaStatusClsCd === '0' ? '0' : '3'
        })
      }
    } else {//社員用
      setForm({
        ...form,
        'aPersonCd': userId,
        qaStatusClsCd: qaContent?.qaStatusClsCd === '0' ? '0' : '2'
      })
      if (qaContent?.custmDepNo && qaContent.keiyakuNo) {
        //契約項目取得&incident,備考取得
        getContractItemList(qaContent?.custmDepNo, userId, token, role).then(res => {
          const val = res.filter(value => value.keiyakuNo === qaContent.keiyakuNo)
          if (val && val.length === 1) {
            setSelectKeiyaku(val[0])
          }
        }).catch(err => handleError(err))
      }
    }
  }, [qaContent]);

  useEffect(() => {
    if (cisUser(role)) {
      if ((form.answerContents.length === 0 || form.answerContents.match(/^(\r\n|\n|\r)+$/)) && form.qaStatusClsCd === '4') {
        setForm({
          ...form,
          qaFlg: 'A',
          answerContents: 'いつもお世話になっています。\r\n\r\nお問合せの件、終了させていただきます。\r\nなお、本件についてのお問合せ、追加のご質問、ご要望等ございましたら、\r\n「Q&A新規登録」にてお問合せください。\r\n\r\nこのたびはCISヘルプラインをご利用頂き、ありがとうございました。\r\n今後ともよろしくお願いいたします。'
        })
      } else if (form.qaStatusClsCd === '3' && form.qaFlg !== 'd') {
        let apersoncd = qaContent?.qPersonCd
        let qaStatusClsCd = qaContent?.qaStatusClsCd
        if (apersoncd && qaStatusClsCd) {
          setForm({
            ...form,
            qaFlg: 'Q',
          })
        }
      } else {
        setForm({
          ...form,
          qaFlg: 'A',
        })
      }
    }
  }, [form.qaStatusClsCd])


  useEffect(() => {
    if (form.qaFlg === 'Q') {
      let apersoncd = qaContent?.qPersonCd
      if (apersoncd) {
        setForm({ ...form, answerClsCd: '0', aPersonCd: apersoncd, })
      }
    } else {
      setForm({ ...form, aPersonCd: userId, })
    }
  }, [form.qaFlg])

  const onSubmitClose = () => {
    putCloseNotice(userId, token, role, decode_qano).then(res => {
      handleNotificationOpen('success', 'クローズお知らせメールの送信')
      handleAddSubmitCount()
      handleCloseMail()
    }).catch(err => { handleCloseMail(); handleError(err) })
  }

  return (
    <React.Fragment>
      <Grid container direction='row' justify='flex-start'>
        <Typography variant='h6' style={{ flexGrow: 1 }}>
          Q&A編集
        </Typography>
        <Button variant='outlined' color='primary' onClick={(event) => handleMovePath()} >
          {qabasicEdit ? 'キャンセル' : '戻る'}
        </Button>
      </Grid >
      <Grid container spacing={2} justify='center' >
        {qaContent === null ?
          <NotFound /> :
          (<React.Fragment>
            {role === rolecustomer &&
              <React.Fragment>
                <Grid item xs={12}>
                  <QAContentCR qaContent={qaContent} fileloading={fileloading} dateFormat={dateFormat} userInfo={userInfo} qaEnvironment={qaEnvironment} fileDownload={fileDownload} userInfoList={userInfoList} />
                </Grid>
                <Grid item xs={12}>
                  <Grid container justify='center' spacing={2}>
                    <Grid item xs={12}>
                      <Paper>
                        <Grid container justify='center' spacing={2}>
                          <Grid item xs={11}>
                            <QAEditAreaCR fileloading={fileloading} dateFormat={dateFormat} qaRest={qaRest} fileDownload={fileDownload} />
                          </Grid>
                          <Grid item xs={11}>
                            <FormAreaCR form={form} loading={loading} handleChangeFile={handleChangeFile} handleChangeForm={handleChangeForm} onSubmit={onSubmit} submitcount={submitcount} qaContent={qaContent} />
                          </Grid>
                        </Grid>
                      </Paper>
                    </Grid>
                  </Grid>
                </Grid>
              </React.Fragment>
            }
            {cisUser(role) &&
              <React.Fragment>
                {qabasicEdit ? (
                  <QABasicEdit qaContent={qaContent} qaEnv={qaEnv} userInfo={userInfo} userInfoList={userInfoList} handleError={handleError} handleNotificationOpen={handleNotificationOpen} handleCloseBasicEdit={handleCloseBasicEdit} handleAddSubmitCount={handleAddSubmitCount} qabasicEdit={qabasicEdit} />
                ) : (
                  <React.Fragment>
                    <Grid item xs={12}>
                      <QAContentEE qaContent={qaContent} fileloading={fileloading} member={member} dateFormat={dateFormat} mailDialog={mailDialog} userInfo={userInfo} qaEnvironment={qaEnvironment} fileDownload={fileDownload} userInfoList={userInfoList} handleOpenBasicEdit={handleOpenBasicEdit} handleOpenMail={handleOpenMail} displayIncident={displayIncident} incidentValidCount={incidentValidCount} incidentRemain={incidentRemain} />
                    </Grid>
                    <Grid item xs={12}>
                      <Grid container justify='center' spacing={2}>
                        <Grid item xs={12}>
                          <Paper>
                            <Grid container justify='center' spacing={2}>
                              <Grid item xs={11}>
                                <QAEditAreaEE fileloading={fileloading} dateFormat={dateFormat} qaRest={qaRest} fileDownload={fileDownload} editindex={editindex} handleQARestEditOpen={handleQARestEditOpen} />
                              </Grid>
                              <Grid item xs={11}>
                                <FormAreaEE form={form} loading={loading} qastatus={qastatus} qastatusorg={qastatusorg} handleChangeFile={handleChangeFile} handleChangeForm={handleChangeForm} onSubmit={onSubmit} submitcount={submitcount} qaContent={qaContent} qaEnv={qaEnv} userInfo={userInfo} userInfoList={userInfoList} handleError={handleError} handleNotificationOpen={handleNotificationOpen} handleCloseBasicEdit={handleCloseBasicEdit} handleAddSubmitCount={handleAddSubmitCount} qabasicEdit={qabasicEdit} answerway={answerway} handleRemoveFile={handleRemoveFile} hadleChangeCloseForm={hadleChangeCloseForm} questionkind={questionkind} handleChangeMinutes={handleChangeMinutes} closeform={closeform} totaltime={totaltime} incidentAddFlg={incidentAddFlg} handleincidentAddFlg={handleincidentAddFlg} incidentcheck={incidentcheck} incidentReqired={incidentReqired} selectKeiyaku={selectKeiyaku} handleQARestEditClose={handleQARestEditClose} editindex={editindex} fileloading={fileloading} fileDownload={fileDownload} fileRemoveButton={fileRemoveButton} newfiles={newfiles} handleDeleteOpen={handleDeleteOpen} />
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>
                      </Grid>
                    </Grid>
                  </React.Fragment>
                )
                }
              </React.Fragment>
            }
            <Dialog
              open={mailDialog}
              onClose={handleCloseMail}
              aria-labelledby='alert-dialog-title-closeMail'
              aria-describedby='alert-dialog-description-closeMail'
            >
              <DialogTitle id='alert-dialog-title-closeMail' ><div className={classes.dialogtitle}><WarningIcon />{' クローズお知らせメール送信'}</div></DialogTitle>
              <DialogContent>
                <DialogContentText id='alert-dialog-description-closeMail'>
                  質問者にメールが送信されます。よろしいですか?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseMail} color='primary' autoFocus >
                  いいえ
                </Button>
                <Button onClick={onSubmitClose} color='primary'>
                  はい
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog
              open={incidentdialog}
              onClose={handleCloseIncident}
              aria-labelledby='alert-dialog-title-incident'
              aria-describedby='alert-dialog-description-incident'
            >
              <DialogTitle id='alert-dialog-title-incident' ><div className={classes.dialogtitle}><WarningIcon />{' 残インシデントが不足しています'}</div></DialogTitle>
              <DialogContent>
                <DialogContentText id='alert-dialog-description-incident'>
                  インシデント登録になりますがよろしいですか?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseIncident} color='primary' autoFocus >
                  いいえ
                </Button>
                <Button onClick={updateIncidentFlg} color='primary'>
                  はい
                </Button>
              </DialogActions>
            </Dialog>

            <Dialog open={deleteopen} onClose={handleDeleteClose} aria-labelledby="alert-dialog-title-delete" aria-describedby="alert-dialog-description-delete">
              <DialogTitle id="alert-dialog-title-delete" ><div className={classes.dialogtitle}><WarningIcon />{" 回答を削除します"}</div></DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description-delete">
                  内容: <br /> {editindex !== -1 && '　' + qaRest[editindex].answerContents}
                  <br />
                  回答作成者: {editindex !== -1 && qaRest[editindex].aPersonName}
                </DialogContentText>
                <DialogContentText style={{ color: 'red' }}>QAのステータスは変更されません。 本当に削除しますか？</DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleDeleteClose} color="primary" autoFocus disabled={loading}>
                  いいえ
                </Button>
                <div className={classes.wrapper}>
                  <Button onClick={onDeleteQARest} color="primary" disabled={loading}>
                    はい
                  </Button>
                  {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                </div>
              </DialogActions>
            </Dialog>
          </React.Fragment>)}
      </Grid>
    </React.Fragment >
  )
}

export default QAEdit
